import { createReducer } from '@reduxjs/toolkit'

const initialState = {}

export default createReducer<{}>(initialState, {})
